import styled from '@emotion/styled';

import { Pink_Light_400 } from '@common/styles';

export const Root = styled.p`
  display: flex;
  align-items: center;

  .discount-rate {
    color: ${Pink_Light_400};
    margin-right: 2px;
  }

  .discount-price {
    color: inherit;
  }
`;
